import type { CatalogEntry } from '../games/catalog';

export const SITE_URL = 'https://playsuperfun.com';
export const SITE_NAME = 'SuperFunUBG';

export const HOME_TITLE = 'SuperFunUBG: Unblocked Games to Play Free Online';
export const HOME_DESCRIPTION =
  'Play 100+ free unblocked games online: shooters, sports, racing, clicker, puzzle and board games. Play solo against a bot or with a friend on one keyboard. No downloads, no sign-up.';

const MODE_TEXT = { solo: 'play solo against a bot', keyboard: 'play with a friend on one keyboard', touch: 'pass and play with a friend' } as const;

export function gameTitle(g: Pick<CatalogEntry, 'name'>): string {
  return `${g.name} Unblocked — Play Free Online | ${SITE_NAME}`;
}

export function gameDescription(g: Pick<CatalogEntry, 'name' | 'tagline' | 'modes' | 'categoryLabel'>): string {
  const modes = g.modes.map((m) => MODE_TEXT[m]);
  const how = modes.length > 1 ? `${modes.slice(0, -1).join(', ')} or ${modes[modes.length - 1]}` : modes[0];
  return `Play ${g.name} unblocked for free. ${g.tagline} A ${g.categoryLabel.toLowerCase()} game: ${how}. No downloads, no sign-up.`;
}

/** Keeps the tab title, meta description and canonical URL in step with the page (search engines run the app). */
export function setPageMeta(title: string, description: string, path: string): void {
  document.title = title;
  let desc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (!desc) {
    desc = document.createElement('meta');
    desc.name = 'description';
    document.head.appendChild(desc);
  }
  desc.content = description;
  let canon = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!canon) {
    canon = document.createElement('link');
    canon.rel = 'canonical';
    document.head.appendChild(canon);
  }
  canon.href = SITE_URL + path;
}

export const setGameMeta = (g: CatalogEntry): void => setPageMeta(gameTitle(g), gameDescription(g), g.path);
